export const DEFAULT_TIMEZONE = "America/Los_Angeles";

export const ANIMATION_SPEED = 1.75;

export const PAGE_SIZE_QUERY_PARAM = "ps";
export const PAGE_INDEX_QUERY_PARAM = "pi";

export const DEFAULT_DATE_FORMAT = "PPPP";
export const DATE_PICKER_FORMAT_MOMENT = "yyyy-MM-DD";
export const DATE_PICKER_FORMAT = "yyyy-MM-dd";

export const MAX_CARD_WIDTH = "1000px";

export const QUERY_KEYS = {
  assignedActions: "assignedActions",
  templatePath: "templatePath",
  templatePaths: "templatePaths",
  templatePathAction: "templatePathAction",
  templateVariables: "templateVariables",
  users: "users",
};

export const TIME_OPTIONS = [
  { label: "0:00", value: "0:00" },
  { label: "1:00", value: "1:00" },
  { label: "2:00", value: "2:00" },
  { label: "3:00", value: "3:00" },
  { label: "4:00", value: "4:00" },
  { label: "5:00", value: "5:00" },
  { label: "6:00", value: "6:00" },
  { label: "7:00", value: "7:00" },
  { label: "8:00", value: "8:00" },
  { label: "9:00", value: "9:00" },
  { label: "10:00", value: "10:00" },
  { label: "11:00", value: "11:00" },
  { label: "12:00", value: "12:00" },
  { label: "13:00", value: "13:00" },
  { label: "14:00", value: "14:00" },
  { label: "15:00", value: "15:00" },
  { label: "16:00", value: "16:00" },
  { label: "17:00", value: "17:00" },
  { label: "18:00", value: "18:00" },
  { label: "19:00", value: "19:00" },
  { label: "20:00", value: "20:00" },
  { label: "21:00", value: "21:00" },
  { label: "22:00", value: "22:00" },
  { label: "23:00", value: "23:00" },
  { label: "24:00", value: "24:00" },
];

export enum TimeRangeKeys {
  BEFORE_NOW = "before_now",
  LAST_28_DAYS = "last_28_days",
  LAST_7_DAYS = "last_7_days",
  YESTERDAY = "yesterday",
  TODAY = "today",
  TOMORROW = "tomorrow",
  NEXT_7_DAYS = "next_7_days",
  NEXT_28_DAYS = "next_28_days",
  AFTER_NOW = "after_now",
}

export interface TimeRangeValue {
  label: string;
  value: TimeRangeKeys;
}

export type TimeRangeType = {
  [K in keyof typeof TimeRangeKeys]: TimeRangeValue;
};

export const TIME_RANGE: Record<TimeRangeKeys, TimeRangeValue> = {
  [TimeRangeKeys.BEFORE_NOW]: {
    label: "Everything",
    value: TimeRangeKeys.BEFORE_NOW,
  },
  [TimeRangeKeys.LAST_28_DAYS]: {
    label: "Last 28 Days",
    value: TimeRangeKeys.LAST_28_DAYS,
  },
  [TimeRangeKeys.LAST_7_DAYS]: {
    label: "Last 7 Days",
    value: TimeRangeKeys.LAST_7_DAYS,
  },
  [TimeRangeKeys.YESTERDAY]: {
    label: "Yesterday",
    value: TimeRangeKeys.YESTERDAY,
  },
  [TimeRangeKeys.TODAY]: {
    label: "Today",
    value: TimeRangeKeys.TODAY,
  },
  [TimeRangeKeys.TOMORROW]: {
    label: "Tomorrow",
    value: TimeRangeKeys.TOMORROW,
  },
  [TimeRangeKeys.NEXT_7_DAYS]: {
    label: "Next 7 Days",
    value: TimeRangeKeys.NEXT_7_DAYS,
  },
  [TimeRangeKeys.NEXT_28_DAYS]: {
    label: "Next 28 Days",
    value: TimeRangeKeys.NEXT_28_DAYS,
  },
  [TimeRangeKeys.AFTER_NOW]: {
    label: "Everything",
    value: TimeRangeKeys.AFTER_NOW,
  },
};

export type IntegrationPartner = "ashby" | "greenhouse" | "lever" | "slack" | "google_calendar" | "zoom" | "roam";

export const PARTNER_INSTRUCTION_URLS: { [key in IntegrationPartner]: string } = {
  ashby: "https://drive.google.com/file/d/1OK6EBFd9q1xSsZODTnm5PCcVZh6Y31u-/view?usp=share_link",
  greenhouse: "https://drive.google.com/file/d/1SjP_xoxIkd58dvDPW-4YV3R8V2lvqvkE/view?usp=share_link",
  lever: "https://drive.google.com/file/d/1NWaBUrL8rRmA9A0PkhDCMaUW9OqRVCEr/view?usp=share_link",
  slack: "https://drive.google.com/file/d/1aWOK5vMS7ItYKpgbYSeE1zt4sL0TV2uf/view?usp=share_link",
  google_calendar: "https://example.com",
  zoom: "https://example.com",
  roam: "https://example.com",
};

export const ACTION_TYPE = {
  MESSAGE: "message",
  EMAIL: "email",
  TASK: "task",
};

export const RELATION_TARET_TYPE: Record<string, string> = {
  BUDDY: "buddy",
  NEW_HIRE: "new_hire",
  MANAGER: "manager",
  PEOPLE_TEAM: "people_team_contact",
  RECRUITER: "recruiter",
  IT_TEAM: "it_team_contact",
};

export const TARGET_TYPE = {
  ONBOARDING_JOURNEY_NETWORK_RELATION: "OnboardingJourneyNetworkRelation",
  USER: "User",
  MESSAGE_SERVICE_CHANNEL: "MessageServiceChannel",
};

export const STAGE = {
  DEPENDENCY: "DEPENDENCY",
  IMMEDIATE: "Preboarding",
  PRE: "Preboarding",
  DAY_1: "Day 1",
  DAY_2: "Day 2",
  WEEK_1: "Week 1",
  WEEK_2: "Week 2",
  MONTH_1: "Month 1",
  MONTH_2: "Month 2",
  MONTH_3: "Month 3",
  AFTER_MONTH_3: "3+ Months",
  AFTER_MONTH_6: "6+ Months",
  AFTER_MONTH_12: "Past 1 Year",
};
